import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  modalHeader: {
    justifyContent: "center",
    borderBottom: "none",
    padding: "10px 0px",
    position: "relative",
    background: "#1F51FF",
    color:"#FFF" 
  },
  warningModalHeaderBackground: {
    background: "#ffc107",
  },
  errorModalHeaderBackground: {
    background: "#FF3C3C",
  },
  withoutHeaderClass: {
    display: "none"
  },
  modalTitle: {
    fontSize: "1.2rem"
  },

  modalBody: {
    justifyContent: "center",
    borderBottom: "none",
    padding: "16px 10px 0 10px",
    textAlign: "center",
    //textTransform: "capitalize",
    //fontSize: "14px"
  },

  modalFooter: {
    justifyContent: "center",
    borderTop: "none",
  },

  buttonStyle: {
    //fontSize: "small"
  },
});

export default styles;
